module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('section', [_vm._m(0), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.randomize('shallow')
      }
    }
  }, [_vm._v("Randomize")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.randomize('deep')
      }
    }
  }, [_vm._v("Deep Randomize")]), _vm._v(" "), _vm._l((_vm.colorConfig), function(octave, index) {
    return _c('div', [_c('div', {
      staticClass: "octaveConfig"
    }, [_c('h2', [_vm._v(_vm._s(octave.name))]), _vm._v(" "), _c('label', [_vm._v("Direction")]), _vm._v(" "), _c('select', {
      domProps: {
        "value": octave.config['flex-direction']
      },
      on: {
        "change": function($event) {
          _vm.updateGroup(index, 'flex-direction', $event.target.value)
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "column"
      }
    }, [_vm._v("Column")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "row"
      }
    }, [_vm._v("Row")])]), _vm._v(" "), _c('select', {
      domProps: {
        "value": octave.config['display']
      },
      on: {
        "change": function($event) {
          _vm.updateGroup(index, 'display', $event.target.value)
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "flex"
      }
    }, [_vm._v("Show [display: flex]")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "none"
      }
    }, [_vm._v("Hide")])]), _vm._v(" "), _vm._l((octave.styles), function(band) {
      return _c('div', [_c('label', [_vm._v("Color")]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "color"
        },
        domProps: {
          "value": band.color
        },
        on: {
          "change": function($event) {
            _vm.updateBand(band.id, index, 'color', $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', [_vm._v("Grow")]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": band.grow
        },
        on: {
          "change": function($event) {
            _vm.updateBand(band.id, index, 'grow', $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', [_vm._v("Offset Top")]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": band.offsetTop
        },
        on: {
          "change": function($event) {
            _vm.updateBand(band.id, index, 'offsetTop', $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', [_vm._v("Offset Left")]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": band.offsetLeft
        },
        on: {
          "change": function($event) {
            _vm.updateBand(band.id, index, 'offsetLeft', $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', [_vm._v("Start Opacity")]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": band.startOpacity
        },
        on: {
          "change": function($event) {
            _vm.updateBand(band.id, index, 'startOpacity', $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', [_vm._v("End Opacity")]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": band.endOpacity
        },
        on: {
          "change": function($event) {
            _vm.updateBand(band.id, index, 'endOpacity', $event.target.value)
          }
        }
      })])
    })], 2)])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("overlay")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f1655e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/overlay_config.vue
// module id = 278
// module chunks = 1